import { render, staticRenderFns } from "./Heart.vue?vue&type=template&id=6eff5642&scoped=true"
import script from "./Heart.vue?vue&type=script&lang=js"
export * from "./Heart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eff5642",
  null
  
)

export default component.exports